import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { CobrancaJudicial } from '../domain/cobranca-judicial.model';

export class CobrancaJudicialSerializer extends DomainSerializer<CobrancaJudicial> {}
